import ReactMarkdown from "react-markdown";
import { EMPTY_FIELD } from "../../../utils/constants";
import { MarkdownLink } from "../../ReactMarkdown/MarkdownLink";
import { RegulatoryDutyDetailRow } from "../../RegulatoryDuties/RegulatoryDutyList/RegulatoryDutyItem/RegulatoryDutyDetailRow/RegulatoryDutyDetailRow";
import { type RegulatoryDutyType } from "../hooks/useRegulatoryDuties";

interface TodoDescriptionProps {
  regulatoryDuty?: RegulatoryDutyType | null;
  userDefinedDescription?: string | null;
}

function TodoDescription({
  regulatoryDuty,
  userDefinedDescription
}: TodoDescriptionProps) {
  if (userDefinedDescription) {
    return (
      <div className="user-defined-description">
        <ReactMarkdown
          components={{
            a: MarkdownLink
          }}
        >
          {userDefinedDescription}
        </ReactMarkdown>
      </div>
    );
  } else if (regulatoryDuty) {
    return (
      <div className="regulatory-duty-rows">
        <RegulatoryDutyDetailRow>
          {regulatoryDuty.description && (
            <ReactMarkdown
              components={{
                a: MarkdownLink
              }}
            >
              {regulatoryDuty.description}
            </ReactMarkdown>
          )}
        </RegulatoryDutyDetailRow>
        <RegulatoryDutyDetailRow title="Empfänger">
          {regulatoryDuty.obligee}
        </RegulatoryDutyDetailRow>
        <RegulatoryDutyDetailRow title="Erfüllungsprozess">
          {regulatoryDuty.fulfillmentProcess && (
            <ReactMarkdown
              components={{
                a: MarkdownLink
              }}
            >
              {regulatoryDuty.fulfillmentProcess}
            </ReactMarkdown>
          )}
        </RegulatoryDutyDetailRow>
        <RegulatoryDutyDetailRow title="Gesetzlich vorgegebene Frist">
          {regulatoryDuty.deadline}
        </RegulatoryDutyDetailRow>
        <RegulatoryDutyDetailRow title="Gesetzliche Grundlage">
          {regulatoryDuty.legalBasis}
        </RegulatoryDutyDetailRow>
        <RegulatoryDutyDetailRow title="Weitere Informationen">
          {regulatoryDuty.additionalInformation && (
            <ReactMarkdown
              components={{
                a: MarkdownLink
              }}
            >
              {regulatoryDuty.additionalInformation}
            </ReactMarkdown>
          )}
        </RegulatoryDutyDetailRow>
      </div>
    );
  } else {
    return <span>{EMPTY_FIELD}</span>;
  }
}

export { TodoDescription, TodoDescriptionProps };
